import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanel,[_c(VExpansionPanelHeader,{staticClass:"blue--text"},[_vm._v("\n\t\tJobs\n\t")]),_c(VExpansionPanelContent,[_c('v-job-results',{ref:"job_search",on:{"click_job":job => _vm.open_job(job.id)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }